/**
 * Leon collection filters drawer (mobile).
 * Single filter groups mount; navigation uses filter link hrefs.
 */
(function () {
  function init(root) {
    var openBtn = root.querySelector('[data-leon-filters-open]');
    var drawer = root.querySelector('[data-leon-filters-drawer]');
    var backdrop = root.querySelector('[data-leon-filters-backdrop]');
    if (!openBtn || !drawer) return;

    var lastFocus = null;

    function setOpen(isOpen) {
      if (isOpen) {
        lastFocus = document.activeElement;
        root.classList.add('is-open');
        if (backdrop) backdrop.hidden = false;
        openBtn.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        document.body.classList.add('leon-filters-open');
        var focusTarget = root.querySelector('[data-leon-filters-close]') || drawer;
        if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
      } else {
        root.classList.remove('is-open');
        if (backdrop) backdrop.hidden = true;
        openBtn.setAttribute('aria-expanded', 'false');
        drawer.removeAttribute('role');
        drawer.removeAttribute('aria-modal');
        document.body.classList.remove('leon-filters-open');
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }
    }

    openBtn.addEventListener('click', function () {
      setOpen(true);
    });

    root.querySelectorAll('[data-leon-filters-close]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        if (el.getAttribute('href') === '#ResultsList') {
          setOpen(false);
          return;
        }
        event.preventDefault();
        setOpen(false);
      });
    });

    if (backdrop) {
      backdrop.addEventListener('click', function () {
        setOpen(false);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        setOpen(false);
      }
    });
  }

  document.querySelectorAll('[data-leon-filters]').forEach(init);
})();
